import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { defaultWMS1020_R01DetailDto, defaultWMS1020_R01HeaderDto, defaultWMS1020_R01LotDto, WMS1020_R01DetailDto, WMS1020_R01HeaderDto, WMS1020_R01LotDto } from './Dto_WMS1020_R01';
import { showWarning } from 'src/utils/toast/toastUtil';
import { getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';
import useUserStore from 'src/store/useUserStore';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { buildLotsByPackQty, buildLotsByPurchaseLotAndPackQty } from 'src/utils/wms/buildLotsByPackQty';


export interface WMS1020_R01Filter {
	
	dateRange: DateRange | undefined;
	wmsOrderNo: string;
	customCd: string;
	customNm: string;
	labelPrintAuto: string;
}
export interface Store_WMS1020_R01 {
	WMS1020_R01Filter: WMS1020_R01Filter;
	WMS1020_R01PastFilter: WMS1020_R01Filter;
	setWMS1020_R01Filter: (filter: Partial<Store_WMS1020_R01['WMS1020_R01Filter']>) => void;
	setWMS1020_R01PastFilter: (filter: Store_WMS1020_R01['WMS1020_R01PastFilter']) => void;
	
	// ====== 매출 리스트 및 선택/편집 ======
	WMS1020_R01List: WMS1020_R01HeaderDto[];
	setWMS1020_R01List: (dataList: WMS1020_R01HeaderDto[]) => void;

	editWMS1020_R01: WMS1020_R01HeaderDto | null;
	setEditWMS1020_R01: (editSale: WMS1020_R01HeaderDto | null) => void;

	selectedWMS1020_R01: WMS1020_R01HeaderDto | undefined;
	setSelectedWMS1020_R01: (data: WMS1020_R01HeaderDto | undefined) => void;
	initSelectedWMS1020_R01: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedWMS1020_R01DetailList: string[];
	setDeletedWMS1020_R01DetailList: (idList: string[]) => void;
	addDeletedWMS1020_R01DetailList: (idList: string[]) => void;
	removeDeletedWMS1020_R01DetailList: (idList?: string[]) => void;

	// ====== 매출 상세(디테일) 데이터 ======
	WMS1020_R01DetailList: WMS1020_R01DetailDto[];
	setWMS1020_R01DetailList: (data: WMS1020_R01DetailDto[]) => void;
	insertWMS1020_R01DetailList: (data: WMS1020_R01DetailDto[], index?: number) => void;
	removeWMS1020_R01DetailList: (index: number) => void;
	updateWMS1020_R01DetailList: (index: number, data: WMS1020_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedWMS1020_R01DetailList: string[];
	setSelectedWMS1020_R01DetailList: (idList: string[]) => void;
	addSelectedWMS1020_R01DetailList: (idList: string[]) => void;
	removeSelectedWMS1020_R01DetailList: (idList?: string[]) => void;
	initSelectedWMS1020_R01DetailList: () => void;

	originalWMS1020_R01DetailList: WMS1020_R01DetailDto[];
	setOriginalWMS1020_R01DetailList: (data: WMS1020_R01DetailDto[]) => void;

	// ====== 입고 상세(lot) 데이터 ======
	WMS1020_R01LotMap: Map<string, WMS1020_R01LotDto[]>;
	setWMS1020_R01LotMap: (data: Map<string, WMS1020_R01LotDto[]>) => void;
	
	selectedItemCdForLot: string | null;
	setSelectedItemCdForLot: (itemCd: string | null) => void;

	lotTotalQty: number;
	setLotTotalQty: (qty: number) => void;
	syncLotTotalQtyFromSelectedDetail: () => void;
	applyLotTotalQty: (qty: number) => boolean;

	purchaseLotNo: string;
	setPurchaseLotNo: (purchaseLotNo: string) => void;
	appliedLotTotalQtyItemCds: string[];
	
	// LotTable의 핸들러들을 위한 함수. 현재 선택된 아이템의 Lot 리스트를 업데이트합니다.
	setWMS1020_R01LotList: (data: WMS1020_R01LotDto[]) => void;

	insertWMS1020_R01LotList: (data: WMS1020_R01LotDto[], index?: number) => void;
	resetWMS1020_R01LotList: (WMS1020_R01DetailList : WMS1020_R01DetailDto[]) => Promise<void>;
	removeWMS1020_R01LotList: (valueIndex: number) => void;	
	updateWMS1020_R01LotList: (valueIndex: number, data: WMS1020_R01LotDto) => void;

	// ====== 입고 상세선택(lot) 행 선택/삭제 관리 ======
	selectedWMS1020_R01LotList: string[];
	setSelectedWMS1020_R01LotList: (idList: string[]) => void;
	addSelectedWMS1020_R01LotList: (idList: string[]) => void;
	removeSelectedWMS1020_R01LotList: (idList?: string[]) => void;
	initSelectedWMS1020_R01LotList: () => void;

	// ====== 입고 상세(lot) 행 선택/삭제 관리 ======
	deletedWMS1020_R01LotList: string[];
	setDeletedWMS1020_R01LotList: (idList: string[]) => void;
	addDeletedWMS1020_R01LotList: (idList: string[]) => void;
	removeDeletedWMS1020_R01LotList: (idList?: string[]) => void;

	originalWMS1020_R01LotList: WMS1020_R01LotDto[];
	setOriginalWMS1020_R01LotList: (data: WMS1020_R01LotDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	lotColumnState: ColumnState[] | null;
	setLotColumnState: (state: ColumnState[] | null) => void;
	
	allCount: number;				setAllCount: (allCount: number) => void;
	

	transportComplete: boolean;		setTransportComplete: (transportComplete: boolean) => void;
	detailFetchTrigger: boolean;	setDetailFetchTrigger: (detailFetchTrigger: boolean) => void;
	lotFetchTrigger: boolean;		setLotFetchTrigger: (lotFetchTrigger: boolean) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	lotScrollTop: number | null;
	setLotScrollTop: (top: number | null) => void;

	// ====== 초기화 ======
	initData: () => void;

	// ====== 유효성 검사 및 동기화 ======
	validateAndSyncLotQty: () => void;
	// 입고합계가 0일 때 첫번째 LOT 수량 자동 설정
	setAutoLotQtyIfEmpty: (detailRow: WMS1020_R01DetailDto) => void;
	// 창고 코드 필터링 (로직센터 & 자재창고 여부)
	warehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	// 공통코드 로드 후 초기값 동기화
	syncInitialData: () => void;

}

// 선택 id(valueIndex)로 입고 목록에서 현재 선택된 품목 행 1건을 찾는다.
const findSelectedDetail = (
	detailList: WMS1020_R01DetailDto[],
	selectedDetailList: string[],
): WMS1020_R01DetailDto | undefined => {
	if (!selectedDetailList.length) return undefined;
	const selectedValueIndex = selectedDetailList[0]?.toString();
	return detailList.find(d => d.valueIndex.toString() === selectedValueIndex);
};

const resolveLotTotalQtyFromDetail = (detail: WMS1020_R01DetailDto | undefined): number => {
	if (!detail) return 0;
	return detail.updateTransportQty > 0 ? detail.updateTransportQty : detail.orderQtyView;
};

export const defaultWMS1020_R01Filter : WMS1020_R01Filter = {
	
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: getFutureWeekdayExceptTodayAndTomorrow()
	},
	wmsOrderNo: '',
	customCd: '',
	customNm: '',
	labelPrintAuto: 'N',
};

const getInitialWMS1020_R01HeaderDto = (): WMS1020_R01HeaderDto => {
	const { wmsCdList, warehouseCdList } = useCommonCodeStore.getState();
	return {
		...defaultWMS1020_R01HeaderDto,
		logicCenter: wmsCdList?.[0]?.minorCd || '',
		warehouseCd: warehouseCdList?.[0]?.warehouseCd || '',
		warehouseNm: warehouseCdList?.[0]?.warehouseNm || '',
	};
};

export const useWMS1020_R01Store = create<Store_WMS1020_R01>((set, get) => ({
	WMS1020_R01Filter: defaultWMS1020_R01Filter,
	WMS1020_R01PastFilter: defaultWMS1020_R01Filter,
	setWMS1020_R01Filter: (update) => set((state) => ({
		WMS1020_R01Filter: {
			...state.WMS1020_R01Filter,
			...update
		}
	})),
	setWMS1020_R01PastFilter: (filter: Store_WMS1020_R01['WMS1020_R01PastFilter']) => set((state) => {
		return {
			...state,
			WMS1020_R01PastFilter: filter
		}
	}),

	// ====== 매출 리스트 및 선택/편집 ======
	WMS1020_R01List: [],
	setWMS1020_R01List: (dataList: WMS1020_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			WMS1020_R01List: dataList
		}
	}),

	editWMS1020_R01: getInitialWMS1020_R01HeaderDto(),
	setEditWMS1020_R01: (editSale: WMS1020_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editWMS1020_R01: editSale
		}
	}),

	selectedWMS1020_R01: undefined,
	setSelectedWMS1020_R01: (data: WMS1020_R01HeaderDto | undefined) => set((state) => {

		return { 
			selectedWMS1020_R01: data, 
			selectedWMS1020_R01DetailList: [], deletedWMS1020_R01DetailList: [],
			selectedWMS1020_R01LotList: [], deletedWMS1020_R01LotList: [],
			WMS1020_R01LotMap: new Map<string, WMS1020_R01LotDto[]>(),
			selectedItemCdForLot: null,
			detailFetchTrigger: true,
			detailScrollTop: null,
			lotScrollTop: null,
			lotTotalQty: 0,
		};
	}),
	initSelectedWMS1020_R01: () => {
		set({ 
			selectedWMS1020_R01: undefined, 
			editWMS1020_R01: getInitialWMS1020_R01HeaderDto(), 
			WMS1020_R01DetailList: [],
			WMS1020_R01LotMap: new Map<string, WMS1020_R01LotDto[]>(),
			selectedItemCdForLot: null,
			detailFetchTrigger: false,
		})
	},

	// ====== 매출 상세(디테일) 데이터 ======
	WMS1020_R01DetailList: [],
	setWMS1020_R01DetailList: (data: WMS1020_R01DetailDto[]) => set((state) => {
		let newList: WMS1020_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultWMS1020_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			WMS1020_R01DetailList: newList
		}
	}),
	insertWMS1020_R01DetailList: (data: WMS1020_R01DetailDto[], index?: number) => set((state) => {
		let newWMS1020_R01DetailList = [...state.WMS1020_R01DetailList];

		let targetRowData = newWMS1020_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newWMS1020_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newWMS1020_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newWMS1020_R01DetailList = newWMS1020_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newWMS1020_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultWMS1020_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newWMS1020_R01DetailList.splice(index, 0, ...newData);
		} else {
			newWMS1020_R01DetailList.push(...newData);
		}

		return {
			...state,
			WMS1020_R01DetailList: newWMS1020_R01DetailList
		}
	}),
	removeWMS1020_R01DetailList: (index: number) => set((state) => {
		const newWMS1020_R01DetailList = [...state.WMS1020_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			WMS1020_R01DetailList: newWMS1020_R01DetailList
		}
	}),
	updateWMS1020_R01DetailList: (valueIndex: number, data: WMS1020_R01DetailDto) => set((state) => {
		const _WMS1020_R01DetailList = state.WMS1020_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			WMS1020_R01DetailList: _WMS1020_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedWMS1020_R01DetailList: [],
	setDeletedWMS1020_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedWMS1020_R01DetailList: idList
		}
	}),
	addDeletedWMS1020_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedWMS1020_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.WMS1020_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.WMS1020_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedWMS1020_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedWMS1020_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedWMS1020_R01DetailList: [...state.deletedWMS1020_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedWMS1020_R01DetailList: [],
	// 품목 선택 시 LOT 조회 키(itemCd)와 주문잔량 입력값을 동기화한다.
	setSelectedWMS1020_R01DetailList: (idList: string[]) => {
		set((state) => {
			const selectedDetail = findSelectedDetail(state.WMS1020_R01DetailList, idList);
			const firstItemCd = selectedDetail?.itemCd || null;

			return {
				...state,
				selectedWMS1020_R01DetailList: idList,
				selectedItemCdForLot: firstItemCd,
				lotFetchTrigger: true,
				lotScrollTop: null,
				lotTotalQty: resolveLotTotalQtyFromDetail(selectedDetail),
				purchaseLotNo: '',
			}
		});

		const selectedDetail = findSelectedDetail(get().WMS1020_R01DetailList, idList);
		if (selectedDetail && selectedDetail.updateTransportQty === 0) {
			get().setAutoLotQtyIfEmpty(selectedDetail);
		}
	},
	addSelectedWMS1020_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedWMS1020_R01DetailList = [...state.selectedWMS1020_R01DetailList];
		if(idList.length > 0) {
			_selectedWMS1020_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedWMS1020_R01DetailList: _selectedWMS1020_R01DetailList
		}
	}),
	removeSelectedWMS1020_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedWMS1020_R01DetailList: [...state.selectedWMS1020_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedWMS1020_R01DetailList: () => set({ selectedWMS1020_R01DetailList: [], lotFetchTrigger: false, lotTotalQty: 0 }),

	originalWMS1020_R01DetailList: [],
	setOriginalWMS1020_R01DetailList: (data: WMS1020_R01DetailDto[]) => set((state) => {
		let newList: WMS1020_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultWMS1020_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalWMS1020_R01DetailList: newList
		}
	}),

	// ====== 입고 상세(lot) 데이터 ======
	WMS1020_R01LotMap: new Map<string, WMS1020_R01LotDto[]>(),
	setWMS1020_R01LotMap: (data: Map<string, WMS1020_R01LotDto[]>) => set({ WMS1020_R01LotMap: data }),

	selectedItemCdForLot: null,
	setSelectedItemCdForLot: (itemCd) => set({ selectedItemCdForLot: itemCd }),

	lotTotalQty: 0,
	setLotTotalQty: (qty) => set({ lotTotalQty: Math.max(0, Number(qty) || 0) }),
	purchaseLotNo: '',
	setPurchaseLotNo: (purchaseLotNo) => set({ purchaseLotNo }),
	appliedLotTotalQtyItemCds: [],
	// 선택 품목의 입고합계/주문잔량을 오른쪽 주문잔량 입력칸에 맞춘다.
	syncLotTotalQtyFromSelectedDetail: () => {
		const state = get();
		const selectedDetail = findSelectedDetail(state.WMS1020_R01DetailList, state.selectedWMS1020_R01DetailList);
		set({ lotTotalQty: resolveLotTotalQtyFromDetail(selectedDetail) });
	},
	// 이번 구매 Lot 수량(x)을 packQty로 나눠 행을 추가한다. 기존 구매 Lot 행은 유지한다.
	applyLotTotalQty: (qty: number) => {
		const state = get();
		const selectedDetail = findSelectedDetail(state.WMS1020_R01DetailList, state.selectedWMS1020_R01DetailList);

		if (!selectedDetail?.itemCd) {
			showWarning('품목을 선택해주세요.');
			return false;
		}

		const normalizedQty = Math.max(0, Number(qty) || 0);
		const maxQty = selectedDetail.orderQtyView;
		const itemCd = selectedDetail.itemCd;
		const isFirstApply = !state.appliedLotTotalQtyItemCds.includes(itemCd);
		const existingLots = (state.WMS1020_R01LotMap.get(itemCd) || []).filter(
			(lot) => !state.deletedWMS1020_R01LotList.includes(lot.valueIndex.toString()),
		);
		const keptSum = isFirstApply
			? 0
			: existingLots.reduce((sum, lot) => sum + (Number(lot.lotQty) || 0), 0);

		if (keptSum + normalizedQty > maxQty) {
			showWarning(`입고량이 주문잔량(${maxQty})보다 클 수 없습니다.`);
			get().syncLotTotalQtyFromSelectedDetail();
			return false;
		}

		const baseLot: WMS1020_R01LotDto = {
			...defaultWMS1020_R01LotDto,
			itemCd,
			lotInputOption: 'N',
			printed: false,
			inserted: true,
		};

		const { lots, error } = buildLotsByPurchaseLotAndPackQty({
			existingLots,
			totalQty: normalizedQty,
			packQty: selectedDetail.packQty,
			purchaseLotNo: state.purchaseLotNo,
			baseLot,
			isFirstApply,
		});

		if (error) {
			showWarning(error);
			return false;
		}

		const newLotMap = new Map(state.WMS1020_R01LotMap);
		newLotMap.set(itemCd, lots);

		const appliedQty = lots.reduce((sum, lot) => sum + (Number(lot.lotQty) || 0), 0);
		const newDetailList = state.WMS1020_R01DetailList.map(item =>
			item.valueIndex === selectedDetail.valueIndex
				? { ...item, updateTransportQty: appliedQty }
				: item
		);

		set({
			WMS1020_R01LotMap: newLotMap,
			WMS1020_R01DetailList: newDetailList,
			lotTotalQty: 0,
			purchaseLotNo: '',
			appliedLotTotalQtyItemCds: isFirstApply
				? [...state.appliedLotTotalQtyItemCds, itemCd]
				: state.appliedLotTotalQtyItemCds,
			deletedWMS1020_R01LotList: state.deletedWMS1020_R01LotList.filter((valueIndex) =>
				!existingLots.some((lot) => lot.valueIndex.toString() === valueIndex),
			),
		});
		return true;
	},

	setWMS1020_R01LotList: (data: WMS1020_R01LotDto[]) => set((state) => {
		const { WMS1020_R01LotMap, selectedItemCdForLot } = state;
		if (!selectedItemCdForLot) return state; // 선택된 아이템이 없으면 아무것도 하지 않음

		const newLotMap = new Map(WMS1020_R01LotMap);
		newLotMap.set(selectedItemCdForLot, data);

		return { WMS1020_R01LotMap: newLotMap };
	}),

	insertWMS1020_R01LotList: async (data: WMS1020_R01LotDto[], index?: number) => {
		const state = get();
		const { WMS1020_R01LotMap, selectedItemCdForLot } = state;
		
		// 1. 데이터 그룹화 (itemCd 기준)
		const dataByItem = new Map<string, WMS1020_R01LotDto[]>();
		data.forEach(item => {
			const targetItemCd = item.itemCd || selectedItemCdForLot;
			if (targetItemCd) {
				const list = dataByItem.get(targetItemCd) || [];
				list.push({ ...item, itemCd: targetItemCd });
				dataByItem.set(targetItemCd, list);
			}
		});

		if (dataByItem.size === 0) return;

		const newLotMap = new Map(WMS1020_R01LotMap);

		// 2. 각 아이템 그룹별로 처리 (기존 생성 로직)
		for (const [itemCd, items] of Array.from(dataByItem.entries())) {
			let targetList = [...(newLotMap.get(itemCd) || [])];
			
			// 기준 행 찾기 (index는 valueIndex라고 가정)
			const pivotRow = (index !== undefined) ? targetList.find(r => r.valueIndex === index) : null;
			
			// 기준 값 설정
			let targetOrderIndex = 1;
			let startSeq = 1;
			
			if (pivotRow) {
				targetOrderIndex = pivotRow.orderIndex;
				startSeq = pivotRow.orderIndexSeq + 1;
				
				// 기존 행들 중 pivotRow 뒤에 오는 행들의 Seq 밀기
				targetList.forEach(row => {
					if (row.orderIndex === targetOrderIndex && row.orderIndexSeq >= startSeq) {
						row.orderIndexSeq += items.length;
					}
				});
			} else if (targetList.length > 0) {
				// 기준 행 없으면 마지막 행 기준
				const last = targetList[targetList.length - 1];
				targetOrderIndex = last.orderIndex;
				startSeq = last.orderIndexSeq + 1;
			}

			newLotMap.set(itemCd, targetList);
		}

		if(selectedItemCdForLot) {
			const targetList = newLotMap.get(selectedItemCdForLot) || [];
			const last = targetList[targetList.length - 1];
			const maxValueIndex = last?.valueIndex || 0;

			//새 행 입력
			const newLow = {
				...defaultWMS1020_R01LotDto,
				valueIndex: maxValueIndex + 1,
				orderIndex: last?.orderIndex || 0,
				orderIndexSeq: maxValueIndex + 1,
				itemCd: selectedItemCdForLot,
				printed: false,
				inserted: true,
			};
			newLotMap.set(selectedItemCdForLot, [...(newLotMap.get(selectedItemCdForLot) || []), newLow]);
		}

		set({ WMS1020_R01LotMap: newLotMap });
		get().validateAndSyncLotQty();
	},

	// 인자로 받은 품목만 LotMap을 새로 만들고, 나머지 품목 LOT는 버린다.
	resetWMS1020_R01LotList: async (WMS1020_R01DetailList : WMS1020_R01DetailDto[]) => {
		const newLotMap = new Map<string, WMS1020_R01LotDto[]>();
		if(!WMS1020_R01DetailList || WMS1020_R01DetailList.length === 0) {
			set({ WMS1020_R01LotMap: newLotMap, appliedLotTotalQtyItemCds: [] });
			return;
		}

		for (const item of WMS1020_R01DetailList) {
			if (!item.itemCd) continue;

			const baseLot: WMS1020_R01LotDto = {
				...defaultWMS1020_R01LotDto,
				itemCd: item.itemCd,
				purchaseLotNo: '',
				lotInputOption: 'N',
				printed: false,
				inserted: true,
			};

			const lots = buildLotsByPackQty(item.orderQtyView, item.packQty, baseLot);
			newLotMap.set(item.itemCd, lots);
		}

		set({
			WMS1020_R01LotMap: newLotMap,
			appliedLotTotalQtyItemCds: [],
		});
		get().validateAndSyncLotQty();
		get().syncLotTotalQtyFromSelectedDetail();
	},

	removeWMS1020_R01LotList: (valueIndex: number) => {
		set((state) => {
			const { WMS1020_R01LotMap, selectedItemCdForLot } = state;
			if (!selectedItemCdForLot) return state;

			const newLotMap = new Map(WMS1020_R01LotMap);
			const targetList = (newLotMap.get(selectedItemCdForLot) || []).filter(item => item.valueIndex !== valueIndex);
			
			newLotMap.set(selectedItemCdForLot, targetList);
			return { WMS1020_R01LotMap: newLotMap };
		});
		get().validateAndSyncLotQty();
	},

	updateWMS1020_R01LotList: (valueIndex: number, data: WMS1020_R01LotDto) => {
		set((state) => {
			const { WMS1020_R01LotMap, selectedItemCdForLot } = state;
			if (!selectedItemCdForLot) return state;

			if(data.lotQty < 0) {
				showWarning('입고량은 0보다 작을 수 없습니다.');
				data.lotQty = 0;
			}

			const newLotMap = new Map(WMS1020_R01LotMap);
			const targetList = (newLotMap.get(selectedItemCdForLot) || []).map(item =>
				item.valueIndex === valueIndex ? data : item
			);

			newLotMap.set(selectedItemCdForLot, targetList);
			return { WMS1020_R01LotMap: newLotMap };
		});
		get().validateAndSyncLotQty();
	},
	
	// ====== 입고 상세(lot) 행 선택/삭제 관리 ======
	deletedWMS1020_R01LotList: [],
	setDeletedWMS1020_R01LotList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedWMS1020_R01LotList: idList
		}
	}),
	addDeletedWMS1020_R01LotList: (idList: string[]) => {
		set((state) => {
			const _deletedLotList = [...state.deletedWMS1020_R01LotList];
			const selectedItemCd = state.WMS1020_R01DetailList.map(item => item.itemCd)[0];
			const newWMS1020_R01LotList = [...state.WMS1020_R01LotMap.get(selectedItemCd) || []];

			for(const valueIndex of idList) {
				const isInserted = newWMS1020_R01LotList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
				const isModified = newWMS1020_R01LotList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
				if(!isInserted && !isModified) {
					_deletedLotList.push(valueIndex);
				}
			}
			
			return {
				...state,
				deletedWMS1020_R01LotList: _deletedLotList,
			}
		});
		get().validateAndSyncLotQty();
	},
	removeDeletedWMS1020_R01LotList: (idList?: string[]) => {
		set((state) => ({
			...state,
			deletedWMS1020_R01LotList: [...state.deletedWMS1020_R01LotList].filter(value => idList ? !idList.includes(value) : false)
		}));
		get().validateAndSyncLotQty();
	},

	selectedWMS1020_R01LotList: [],
	setSelectedWMS1020_R01LotList: (idList: string[]) => {
		set((state) => {
			return {
				...state,
				selectedWMS1020_R01LotList: idList,
			}
		});
		get().validateAndSyncLotQty();
	},
	addSelectedWMS1020_R01LotList: (idList: string[]) => set((state) => {
		const _selectedWMS1020_R01LotList = [...state.selectedWMS1020_R01LotList];
		if(idList.length > 0) {
			_selectedWMS1020_R01LotList.push(...idList);
		}
		return {
			...state,
			selectedWMS1020_R01LotList: _selectedWMS1020_R01LotList
		}
	}),
	removeSelectedWMS1020_R01LotList: (idList?: string[]) => set((state) => ({
		...state,
		selectedWMS1020_R01LotList: [...state.selectedWMS1020_R01LotList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedWMS1020_R01LotList: () => set({ selectedWMS1020_R01LotList: [] }),	

	originalWMS1020_R01LotList: [],
	setOriginalWMS1020_R01LotList: (data: WMS1020_R01LotDto[]) => set((state) => {
		let newList: WMS1020_R01LotDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultWMS1020_R01LotDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalWMS1020_R01LotList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	lotColumnState: null,
	setLotColumnState: (state: ColumnState[] | null) => set({ lotColumnState: state }),
	
	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
						

	transportComplete: false,		setTransportComplete: (transportComplete: boolean) => set({ transportComplete }),
	detailFetchTrigger: false,		setDetailFetchTrigger: (detailFetchTrigger: boolean) => set({ detailFetchTrigger }),
	lotFetchTrigger: false,			setLotFetchTrigger: (lotFetchTrigger: boolean) => set({ lotFetchTrigger }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
	lotScrollTop: null,
	setLotScrollTop: (top: number | null) => set({ lotScrollTop: top }),

	// ====== 초기화 ======
	initData: () => {
		set((state) => ({
		...state,

		WMS1020_R01Filter: defaultWMS1020_R01Filter,
		WMS1020_R01PastFilter: defaultWMS1020_R01Filter,

		WMS1020_R01List: [],
		selectedWMS1020_R01: undefined,
		originalWMS1020_R01List: [],

		WMS1020_R01LotMap: new Map<string, WMS1020_R01LotDto[]>(),
		originalWMS1020_R01LotList: [],
		selectedItemCdForLot: null,

		
		WMS1020_R01DetailList: [],
		deletedWMS1020_R01DetailList: [],
		selectedWMS1020_R01DetailList: [],
		originalWMS1020_R01DetailList: [],
		editWMS1020_R01: getInitialWMS1020_R01HeaderDto(),
		allCount: 0,
		

		transportComplete: false,
		detailFetchTrigger: false,
		lotFetchTrigger: false,
		scrollTop: null,
		detailScrollTop: null,
		lotScrollTop: null,
		lotTotalQty: 0,
		purchaseLotNo: '',
		appliedLotTotalQtyItemCds: [],
	}))},

	//입고합계가 0인 DetailRow가 있을 때 자동으로 LOT 수량을 설정
	setAutoLotQtyIfEmpty: (detailRow: WMS1020_R01DetailDto) => {
		const state = get();
		const { WMS1020_R01LotMap } = state;

		// 입고합계가 0일 때만 동작
		if (detailRow.updateTransportQty !== 0) return;

		const itemCd = detailRow.itemCd;
		if (!itemCd) return;

		const baseLot: WMS1020_R01LotDto = {
			...defaultWMS1020_R01LotDto,
			itemCd,
			purchaseLotNo: '',
			lotInputOption: 'N',
			printed: false,
			inserted: true,
		};

		const newLotList = buildLotsByPackQty(detailRow.orderQtyView, detailRow.packQty, baseLot);
		const newMap = new Map(WMS1020_R01LotMap);
		newMap.set(itemCd, newLotList);

		set({ WMS1020_R01LotMap: newMap });
		setTimeout(() => get().validateAndSyncLotQty(), 0);
	},

	warehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		const filteredList = warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& (value.materialYn === 'Y')
		));
		
		if (filteredList.length === 0) {
			return [{ warehouseCd: '', warehouseNm: '' } as WareHouseDto];
		}
		
		return filteredList;
	},

	syncInitialData: () => {
		const { wmsCdList } = useCommonCodeStore.getState();
		const state = get();
		
		// 이미 값이 있거나 공통코드가 없으면 리턴
		if ((state.editWMS1020_R01?.logicCenter && state.editWMS1020_R01?.warehouseCd) || wmsCdList.length === 0) return;

		const defaultLogicCenter = wmsCdList?.[0]?.minorCd || '';
		
		// 스토어 내부 함수를 사용하여 유효한 창고 목록을 가져옴
		const availableWarehouses = state.warehouseCdListToUseList(defaultLogicCenter);
		const defaultWarehouseCd = availableWarehouses?.[0]?.warehouseCd || '';
		const defaultWarehouseNm = availableWarehouses?.[0]?.warehouseNm || '';

		set((state) => ({
			editWMS1020_R01: {
				...state.editWMS1020_R01!,
				logicCenter: defaultLogicCenter,
				warehouseCd: defaultWarehouseCd,
				warehouseNm: defaultWarehouseNm,
			}
		}));
	},

	validateAndSyncLotQty: () => {
		const state = get();
		const { WMS1020_R01LotMap, WMS1020_R01DetailList, deletedWMS1020_R01LotList } = state;
		
		const lotQtySums = new Map<string, number>();
		const crashItems = new Map<string, number>(); // itemCd -> crashIndex

		let valid = true;

		WMS1020_R01LotMap.forEach((lots, itemCd) => {
			// 해당 품목의 주문 수량(orderQty) 찾기
			const detailItem = WMS1020_R01DetailList.find(d => d.itemCd === itemCd);
			const maxQty = detailItem ? detailItem.orderQty : 0;

			let currentSum = 0;
			let crashIndex = -1;

			// Lot들을 순회하며 합계 계산 및 초과 지점 탐색
			lots.forEach((lot, index) => {
				// 삭제된 lot은 계산에서 제외
				if (deletedWMS1020_R01LotList.includes(lot.valueIndex.toString())) {
					return;
				}

				const qty = Number(lot.lotQty || 0);
				// 현재까지의 합계 + 이번 lot수량이 주문량을 초과하면
				if (currentSum + qty > maxQty) {
					// 아직 범인을 못 찾았고, 수량이 0보다 큰 경우
					if (crashIndex === -1 && qty > 0) {
						crashIndex = index;
						valid = false;
						showWarning(`입고량이 주문량(${maxQty})보다 클 수 없습니다. - 품목코드: ${itemCd}`);
					}
				}
				currentSum += qty;
			});

			lotQtySums.set(itemCd, currentSum);
			if (crashIndex !== -1) {
				crashItems.set(itemCd, crashIndex);
			}
		});

		//valid가 false면 문제가 생긴 행의 입고량을 0으로 설정
		if (!valid && crashItems.size > 0) {
			const newLotMap = new Map(WMS1020_R01LotMap);
			let isUpdated = false;

			crashItems.forEach((targetIndex, itemCd) => {
				const currentLots = newLotMap.get(itemCd) || [];
				if (currentLots.length > targetIndex) {
					const targetList = currentLots.map((lot, index) => {
						if (index === targetIndex) {
							return { ...lot, lotQty: 0 };
						}
						return lot;
					});

					// 변경사항이 있을 때만 업데이트하여 무한루프 방지
					if (JSON.stringify(currentLots) !== JSON.stringify(targetList)) {
						newLotMap.set(itemCd, targetList);
						isUpdated = true;
					}
				}
			});

			if (isUpdated) {
				set({ WMS1020_R01LotMap: newLotMap });
				// 0으로 초기화 후 다시 계산을 위해 재귀 호출
				get().validateAndSyncLotQty();
				return;
			}
		}

		const needsUpdate = WMS1020_R01DetailList.some(detailItem => {
			const sum = lotQtySums.get(detailItem.itemCd);
			return sum !== undefined && detailItem.updateTransportQty !== sum;
		});

		const stateUpdates: Partial<Store_WMS1020_R01> = {};

		if (needsUpdate && valid) {
			stateUpdates.WMS1020_R01DetailList = WMS1020_R01DetailList.map(detailItem => {
				const sum = lotQtySums.get(detailItem.itemCd);
				if (sum !== undefined && detailItem.updateTransportQty !== sum) {
					return { ...detailItem, updateTransportQty: sum };
				}
				return detailItem;
			});
		}

		if (Object.keys(stateUpdates).length > 0) {
			set(stateUpdates);
		}
	},

}));
